/* eslint-disable no-extra-bind */
const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class SampleScan extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
		this.InAddMode = false;
		this.currentScannedSampleResult = null;
	}

	onBeforeRenderAsync(pCallback)
	{
		if (pCallback)
		{
			pCallback();
		};
	}

	onAfterRenderAsync(pCallback)
	{
		// start a new QR code scanning workflow
		this.customOpenQRScannerWorkflow();
		// if there is a callback function, call it
		if (pCallback)
		{
			pCallback();
		}
	}

	customOpenQRScannerWorkflow()
	{
		this.currentScannedSampleResult = null;
		this.pict.providers.QRCodeProvider.startWorkflow((e) =>
		{
			console.log('[Sample Scan Panel] Received QREvent: ', e);
			if (e.event === 'scanned-Sample')
			{
				if (e.payload.IDSample)
				{
					// stop the QR code scanning workflow
					this.pict.views.QRPanel.toggleCamera();
					// handle the scanned sample selection
					this.currentScannedSampleResult = e.payload;
					this.handleSampleScanSelection(null, e.payload.IDSample, e.payload);
				}
			}
		});
	}

	/**
	 * This function is used to handle the selection of a sample from the scan results.
	 * @param {Event} event - The event that triggered the selection
	 * @param {string} pIDSample - The ID of the sample that was selected
	 * @param {object} pSampleObject - The sample object that was selected
	 * @return {void}
	 */
	handleSampleScanSelection(event, pIDSample, pSampleObject)
	{
		// determine if we are in "add to set" mode
		this.InAddMode = this.pict.ContentAssignment.readAttribute('#HeadlightPanels-SamplePanel', 'data-panel-mode') === 'add-to-set';

		if (!pIDSample)
		{
			this.log.error('No IDSample provided');
			return;
		}
		// handle the context of the sample selection
		if (this.InAddMode)
		{
			if (this.pict.views.SampleSearch.sampleSelectionCallback)
			{
				if (pIDSample && pSampleObject)
				{
					this.pict.views.SampleSearch.sampleSelectionCallback(pSampleObject);
					this.pict.views.HeadlightPanels.handlePanelToggle('Samples', 'close');
					this.InAddMode = false;
				}
			}
		}
		else
		{
			if (_Pict.PictApplication.options.Name == 'LIMS')
			{
				this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
				window.open(`#/Sample/${ pSampleObject.GUIDSample }`, '_self');
			}
			else
			{
				this.pict.views.SampleDetails.showSampleDetailView(pIDSample, null, 'Details');
			}
		}
	}
}

module.exports = SampleScan;

module.exports.default_configuration =
{
	ViewIdentifier: 'SampleScan',
	DefaultRenderable: 'SampleScan',
	DefaultDestinationAddress: '#SampleScan-Container',
	Templates:
		[
			{
				Hash: 'SampleScan',
				Template: /*html*/`
				<div id="SampleScan-Content" class="container">
					<style>
						.sample-container {
							overflow: scroll;
						}
						.panel-content-samples {
							max-height: calc(100vh - var(--panels-header-height) - var(--panels-navbar-height)) !important;
							overflow-y: scroll !important;
						}
						.icon-text-for-open-button
						{
							display: inline;
						}
						.icon-text-for-close-button
						{
							display: none;
						}
						.is-close-button .icon-text-for-close-button
						{
							display: inline;
						}
						.is-close-button .icon-text-for-open-button
						{
							display: none;
						}
					
					</style>
					<div id="QRPanel-SampleScan-Container" class="has-background-text-35 has-text-white" style="max-height: 50vh; overflow-y: scroll;">
						<style>
							@media screen and (max-width: 768px) {
								#QRPanel-ScannerBox__scan_region > video {
									max-height: 180px;
									object-fit: cover;
								}
							}
						</style>
						<div id="QRPanel-ScannerBox-Outer" class="is-hidden">
							<div id="QRPanel-ScannerBox"></div>
						</div>
					</div>
					<div class="notification is-dark has-text-text-65 mx-4 mt-4 mb-0 scanning-instructions">
						<span class="icon-text">
							<span class="icon">
								<i class="fas fa-fw fa-info-circle"></i>
							</span>
							<span>
								Point your device camera or scanner gun at a QR code to select a valid sample.
							</span>
						</span>
					</div>
					<div class="columns m-0 is-mobile">
						<div class="column is-6">
							<button type="button" id="QRPanel-CameraButton" class="button is-primary is-fullwidth" onclick="_Pict.views.QRPanel.toggleCamera()">
								<span class="icon mr-3">
									<i class="fas fa-fw fa-camera-viewfinder"></i>
								</span>
								<span class="icon-text icon-text-for-open-button">Open Camera</span>
								<span class="icon-text icon-text-for-close-button">Close Camera</span>
							</button>
						</div>
					</div>
				
				</div>`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'SampleScan',
				TemplateHash: 'SampleScan',
				DestinationAddress: '#SampleScan-Container',
			},
		],
};
